<template>
  <div id="invitation-expired-message">
    <h1>{{ $t("onboard.invitationExpiredMessage.header") }}</h1>
    <p v-html="$t('onboard.invitationExpiredMessage.text')"></p>
    <router-link to="/login" >{{ $t('onboard.invitationExpiredMessage.loginLink') }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'InvitationExpiredMessage'
}
</script>
